export const REQUIREMENTS_FINGERPRINT_VERSION = "requirements-fingerprint-v1";
export function requirementsFingerprint(requirements) {
    const canonical = requirements
        .map(canonicalRequirement)
        .sort((left, right) => left.id.localeCompare(right.id));
    return `${REQUIREMENTS_FINGERPRINT_VERSION}:${fnv1a64(stableStringify(canonical))}`;
}
function canonicalRequirement(requirement) {
    return {
        id: requirement.id,
        projectId: requirement.projectId,
        scope: requirement.scope,
        type: requirement.type,
        interpretedText: requirement.interpretedText,
        priority: requirement.priority,
        status: requirement.status,
        confidence: requirement.confidence,
        overrideState: requirement.overrideState,
        createdBy: requirement.createdBy,
        sourceRefs: requirement.sourceRefs,
        ...(requirement.tags ? { tags: requirement.tags } : {}),
        ...(requirement.uiStrategy ? { uiStrategy: requirement.uiStrategy } : {}),
        ...(requirement.edgeFeature ? { edgeFeature: requirement.edgeFeature } : {}),
        ...(requirement.thirdPartyIntegration
            ? { thirdPartyIntegration: requirement.thirdPartyIntegration }
            : {}),
        ...(requirement.productQuantity
            ? { productQuantity: requirement.productQuantity }
            : {}),
        ...(requirement.policyFlagRefs ? { policyFlagRefs: requirement.policyFlagRefs } : {}),
        interactsWith: requirement.interactsWith,
        canSubstituteFor: requirement.canSubstituteFor
    };
}
function stableStringify(value) {
    if (value === null || typeof value !== "object") {
        return JSON.stringify(value);
    }
    if (Array.isArray(value)) {
        return `[${value.map(stableStringify).join(",")}]`;
    }
    const record = value;
    const entries = Object.keys(record)
        .sort()
        .flatMap((key) => record[key] === undefined
        ? []
        : [`${JSON.stringify(key)}:${stableStringify(record[key])}`]);
    return `{${entries.join(",")}}`;
}
function fnv1a64(value) {
    let hash = 0xcbf29ce484222325n;
    const prime = 0x100000001b3n;
    const mask = 0xffffffffffffffffn;
    for (let index = 0; index < value.length; index += 1) {
        hash ^= BigInt(value.charCodeAt(index));
        hash = (hash * prime) & mask;
    }
    return hash.toString(16).padStart(16, "0");
}
//# sourceMappingURL=requirementsFingerprint.js.map